module.exports = __webpack_public_path__ + "img/betterPractices.67e6cf48.png";